import apiService from '../apiService';

const SUPER_ADMIN_URL = '/super-admin'
const settingService = {
  // Normal Admin / Tenant
  async userSessions() {
    try {
      const response = await apiService.get('/settings/user-sessions');
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteSession(id) {
    try {
      const response = await apiService.delete(`/settings/user-sessions/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteAllSession() {
    try {
      const response = await apiService.delete(`/settings/user-sessions/delete`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Super Admin
  async superAdminUserSessions() {
    try {
      const response = await apiService.get(`${SUPER_ADMIN_URL}/user-sessions`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminDeleteSession(id) {
    try {
      const response = await apiService.delete(`${SUPER_ADMIN_URL}/user-sessions/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminDeleteAllSession() {
    try {
      const response = await apiService.delete(`${SUPER_ADMIN_URL}/user-sessions/delete`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Roles And Permissions

  async getPermisionsGroup() {
    try {
      const response = await apiService.get(`/settings/roles/get/permissions`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async createRole(payload) {
    try {
      const response = await apiService.post(`/settings/roles/store`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateRole(payload, id) {
    try {
      const response = await apiService.put(`/settings/roles/update/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

    async getAllRolesList() {
    try {
      const response = await apiService.get(`/settings/roles/listings`, );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getAllRoles() {
    try {
      const response = await apiService.get(`/settings/roles`, );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleRole(id) {
    try {
      const response = await apiService.get(`/settings/roles/${id}`, );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteRole(id) {
    try {
      const response = await apiService.delete(`/settings/roles/delete/${id}`, );
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default settingService;